"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useTooltipStyles = () => {
    const theme = (0, material_1.useTheme)();
    const tooltipPopper = { zIndex: '1000 !important' };
    const tooltip = {
        backgroundColor: '#f5ebfc !important',
        fontSize: '0.9375rem !important',
        padding: '12px 8px !important',
        maxWidth: 'calc(min(100vw, 580px) - 48px) !important',
    };
    const content = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: '1.3em',
    };
    const iconandAction = {
        width: '36px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg': { fontSize: '24px', color: theme.qlub.palette.iris.main },
    };
    const actionBtn = {
        padding: '2px',
    };
    const textStyle = { color: `${theme.qlub.palette.iris.main} !important`, padding: '0 0 0 8px' };
    const arrow = { color: theme.qlub.palette.iris_light.main };
    return {
        tooltipPopper,
        tooltip,
        content,
        iconandAction,
        actionBtn,
        textStyle,
        arrow,
    };
};
exports.default = useTooltipStyles;
